import { useState } from "react";
import { Button, Modal, Pagination, PaginationItem, PaginationLink, Spinner } from "reactstrap";
import "./historyModal.scss"

const HistoryModal = ({
  fetchHistory,       
  columns,            
  data,               
  loading,            
  trigger,           
  onDetail,
  errorLoadingHistory,
  variant, 
  downloadHistoryPdf,
  downloadHistoryDocx,

  handlePageChange,
  totalPages,
  currentPage,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const handleOpen = (e) => {
    e.stopPropagation();
    if (!isOpen) {
      fetchHistory();
    }
    toggle();
  };
  return (
    <>
      <div onClick={handleOpen}>
        {trigger}
      </div>

      <Modal size="lg" centered={true} isOpen={isOpen} toggle={toggle}>
        <div className="">
          <h5 className="mt-0 history-title">Version History</h5>
        </div>

        <div className="modal-body">
          {loading && (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ height: "400px", width: "100%" }}
            >
              <Spinner color="primary" style={{ height: "5rem", width: "5rem" }} />
            </div>
          )}

          {!loading && data?.length > 0 ? (
            <>
              {data.map((item, i) => (
                <div key={i} className={`row-history ${variant === "documents" && "row-history--document"}`}>
                  {columns.map((col, idx) => (
                    <div key={idx} className={`rows-history ${variant === "documents" && "rows-history--document"}`}>
                      {col.render ? col.render(item) : item[col.key]}
                    </div>
                  ))}

                  {onDetail && (
                    <div className="rows-history-btn">
                      <Button
                        color=""
                        className="icon-only-btn"
                        onClick={() => onDetail(item)}
                      >
                        <i className="fas fa-search"></i>
                      </Button>
                      
                      {(item.status === "Approved" || item.status === "Published") && (
                        <>
                          <Button 
                            color=""
                            className="icon-only-btn px-0"
                            onClick={() => downloadHistoryPdf(item)}
                          >
                            <svg
                              width={18}
                              height={20}
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 640 640"
                            >
                              <path
                                fill="#E83E8C"
                                d="M128 64C92.7 64 64 92.7 64 128L64 512C64 547.3 92.7 576 128 576L208 576L208 464C208 428.7 236.7 400 272 400L448 400L448 234.5C448 217.5 441.3 201.2 429.3 189.2L322.7 82.7C310.7 70.7 294.5 64 277.5 64L128 64zM389.5 240L296 240C282.7 240 272 229.3 272 216L272 122.5L389.5 240zM272 444C261 444 252 453 252 464L252 592C252 603 261 612 272 612C283 612 292 603 292 592L292 564L304 564C337.1 564 364 537.1 364 504C364 470.9 337.1 444 304 444L272 444zM304 524L292 524L292 484L304 484C315 484 324 493 324 504C324 515 315 524 304 524zM400 444C389 444 380 453 380 464L380 592C380 603 389 612 400 612L432 612C460.7 612 484 588.7 484 560L484 496C484 467.3 460.7 444 432 444L400 444zM420 572L420 484L432 484C438.6 484 444 489.4 444 496L444 560C444 566.6 438.6 572 432 572L420 572zM508 464L508 592C508 603 517 612 528 612C539 612 548 603 548 592L548 548L576 548C587 548 596 539 596 528C596 517 587 508 576 508L548 508L548 484L576 484C587 484 596 475 596 464C596 453 587 444 576 444L528 444C517 444 508 453 508 464z"
                              />
                            </svg>    
                          </Button>
                          <Button 
                            color=""
                            className="icon-only-btn px-0"
                            onClick={() => downloadHistoryDocx(item)}
                          >
                            <svg
                              width={18}
                              height={20}
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 640 640"
                            >
                              <path
                                fill="#0576B9"
                                d="M128 128C128 92.7 156.7 64 192 64L341.5 64C358.5 64 374.8 70.7 386.8 82.7L493.3 189.3C505.3 201.3 512 217.6 512 234.6L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 128zM336 122.5L336 216C336 229.3 346.7 240 360 240L453.5 240L336 122.5zM263.4 338.8C260.5 325.9 247.7 317.7 234.8 320.6C221.9 323.5 213.7 336.3 216.6 349.2L248.6 493.2C250.9 503.7 260 511.4 270.8 512C281.6 512.6 291.4 505.9 294.8 495.6L320 419.9L345.2 495.6C348.6 505.8 358.4 512.5 369.2 512C380 511.5 389.1 503.8 391.4 493.2L423.4 349.2C426.3 336.3 418.1 323.4 405.2 320.6C392.3 317.8 379.4 325.9 376.6 338.8L363.4 398.2L342.8 336.4C339.5 326.6 330.4 320 320 320C309.6 320 300.5 326.6 297.2 336.4L276.6 398.2L263.4 338.8z"
                              />
                            </svg>   
                          </Button>
                        </>
                      )}
                    
                    </div>
                  )}
                </div>
              ))}
              <div className="d-flex justify-content-end mt-3">
                <Pagination className="mb-0" style={{display: 'flex', gap: '0.5rem'}} >
                  {/* PREV */}
                  {currentPage > 1 &&
                    <PaginationItem disabled={ currentPage === 1} style={{minWidth: "100px"}}>
                      <PaginationLink
                        previous
                        onClick={() => handlePageChange(currentPage - 1)}
                        className="d-flex align-items-center justify-content-center"
                        style={{ width: "100%" }}
                      >
                        <span aria-hidden="true">&laquo;</span>
                        <span style={{fontSize: "12px", marginLeft: "8px"}}>Previous</span>
                      </PaginationLink>
                    </PaginationItem>
                  }

                  {/* NEXT */}
                  { currentPage < totalPages &&
                    <PaginationItem disabled={currentPage === totalPages} style={{minWidth: "100px"}}>
                      <PaginationLink
                        next
                        onClick={() => handlePageChange(currentPage + 1)}
                        className="d-flex align-items-center justify-content-center"
                        style={{ width: "100%" }}
                      >
                        <span style={{fontSize: "12px", marginRight: "8px"}}>Next</span>
                        <span aria-hidden="true">&raquo;</span>
                      </PaginationLink>
                    </PaginationItem>
                  }
                </Pagination>
              </div>
            </>
          ) : (
            !loading && <p className="text-center">{errorLoadingHistory ? "Error loading history" : "No history found"}</p>
          )}
        </div>
      </Modal>
    </>
  );
};

export default HistoryModal;
